const teal = {
  100: '#E4F4F8',
  light: '#92D9D5',
  main: '#2595A5',
  dark: '#3A719B'
};
export default teal;